// @flow
import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import appStyles from '../../../../config/appStyles.js';
import loaderIcon from '../../../../assets/images/loader.svg';

const useStyles = makeStyles((theme) => appStyles.addressProcessingBanner(theme));

// Own stylesheet on purpose: this banner is rendered inside the global Alert, which
// outlives the component that opens it.
// `compact` is the short wording used where there is no room for the full message
const AddressProcessingBanner = ({ className, compact }) => {
  const classes = useStyles();
  const { t } = useTranslation(['components']);
  const ns = 'components:AddressProcessingBanner.';

  return (
    <Box className={clsx(classes.root, className)}>
      <img className={classes.icon} src={loaderIcon} alt="" />
      <Box className={classes.text}>
        {compact ? (
          <strong>{t(ns + 'compact')}</strong>
        ) : (
          <>
            <strong>{t(ns + 'title')}</strong> {t(ns + 'text')}
          </>
        )}
      </Box>
    </Box>
  );
};

export default AddressProcessingBanner;
